import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip, Button, InputGroup } from 'react-bootstrap';
//import { Link, useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
//import ProductList from './ProjectList';
//import ProductGrid from './ProjectGrid';
import usePagination from 'hooks/usePagination';
//import Flex from 'components/common/Flex';
//import { useMutation } from '@tanstack/react-query';
//import { projectService } from 'services';
//import { AllProjectContext } from 'context/Context';
import ProjectList from './ProjectList';
import Background from 'components/common/Background';
import corner6 from 'assets/img/illustrations/corner-6.png';
//import AdvanceTablePagination from 'components/common/tables/AdvanceTablePagination';
import Pagination from 'components/common/Pagination';

const AllPorjects = ({ data }) => {
 //const [sortBy, setSortBy] = useState('price');
 const [isAsc, setIsAsc] = useState(true);
 //const [productPerPage, setProductPerPage] = useState(4);
 const [layout, setLayout] = useState('list');

 const toggleLayout = () => {
  setLayout(prevLayout => (prevLayout === 'list' ? 'grid' : 'list'));
 };

 const isList = layout === 'list';
 const isGrid = layout === 'grid';

 const {
  paginationState: {
   data: paginatedProject,
   totalItems,
   //itemsPerPage,
   currentPage,
   canNextPage,
   canPreviousPage,
   paginationArray
   //from,
   //to
  },
  nextPage,
  prevPage,
  goToPage
  //setItemsPerPage
 } = usePagination(data, 4); // productPerPage);

 /* useEffect(() => {
  productsDispatch({
   type: 'SORT_PRODUCT',
   payload: {
    sortBy,
    order: isAsc ? 'asc' : 'desc'
   }
  });
 }, [sortBy, isAsc]); */

 return (
  <>
   <Card className="mb-3">
    <Card.Header className="position-relative">
     <div className="flex-grow-1 fs--2">
      <h5 className="mb-0 text-primary">Proyectos</h5>
      <p className="mb-0">Ajilice sus proyectos</p>
     </div>
     <Background image={corner6} className="d-none d-md-block bg-card" />
    </Card.Header>
    <Card.Body className="pt-0 pt-md-3">
     <Row className="g-3 align-items-center">
      <Col xs="auto" className="d-xl-none">
       <Button className="position-relative p-0" size="sm" variant="link">
        <FontAwesomeIcon icon="filter" className="fs-0 text-700" />
       </Button>
      </Col>
      <Col>
       <Form className="position-relative">
        <Form.Control
         type="search"
         placeholder="Search..."
         size="sm"
         aria-label="Search"
         className="rounded search-input ps-4"
         //onChange={({ target }) => handleSearch(target.value)}
        />
        <FontAwesomeIcon
         icon="search"
         className="fs--1 text-400 position-absolute text-400 start-0 top-50 translate-middle-y ms-2"
        />
       </Form>
      </Col>
      {/* <Col sm="auto" as={Flex} alignItems="center" className="mb-2 mb-sm-0">
       <Form.Select
        size="sm"
        value={itemsPerPage}
        onChange={({ target }) => {
         setItemsPerPage(target.value);
         setProductPerPage(target.value);
        }}
        style={{ maxWidth: '4.875rem' }}
       >
        <option value={2}>2</option>
        <option value={4}>4</option>
        <option value={6}>6</option>
        <option value={totalItems}>All</option>
       </Form.Select>
       <h6 className="mb-0 ms-2">
        Showing {from}-{to} of {totalItems} Products
       </h6>
      </Col> */}

      <Col xs="auto" className="col-md">
       <Row className="g-0 justify-content-end">
        <Col xs="auto" className="position-md-static position-absolute top-0 end-0 me-3 mt-3 mt-md-1">
         <Form as={Row} className="gx-2">
          <Col xs="auto" className="d-none d-lg-block">
           <small>Sort by:</small>
          </Col>
          <Col xs="auto">
           <InputGroup size="sm">
            <Form.Select
             className="pe-5"
             defaultValue="price"
             style={{ maxWidth: '6.7rem' }}
             //onChange={({ target }) => setSortBy(target.value)}
            >
             <option value="price">Price</option>
             <option value="rating">Rating</option>
             <option value="review">Review</option>
            </Form.Select>
            <InputGroup.Text as={Button} variant="link" className="border border-300 text-700" onClick={() => setIsAsc(!isAsc)}>
             <FontAwesomeIcon icon={isAsc ? 'sort-amount-up' : 'sort-amount-down'} />
            </InputGroup.Text>
           </InputGroup>
          </Col>
         </Form>
        </Col>

        <Col xs="auto" className="p-0">
         <Row className="g-2 align-items-center">
          <Col xs="auto mb-1 mb-md-0">
           <OverlayTrigger
            placement="top"
            overlay={<Tooltip style={{ position: 'fixed' }}>Product {isList ? 'Grid' : 'List'}</Tooltip>}
           >
            <Button variant="link" className="text-600 px-1" onClick={toggleLayout}>
             <FontAwesomeIcon icon={classNames({ th: isGrid, 'list-ul': isList })} />
            </Button>
           </OverlayTrigger>
          </Col>
         </Row>
        </Col>
       </Row>
      </Col>
     </Row>
    </Card.Body>
   </Card>

   <Row
    className={classNames('g-3 mb-3', {
     'g-3': isList
    })}
   >
    {paginatedProject?.map((product, index) =>
     layout === 'list' ? (
      <Col key={product.id} xs={12}>
       <ProjectList product={product} index={index} />
      </Col>
     ) : (
      <Col key={product.id} xs={12}>
       <ProjectList product={product} index={index} />
      </Col>
      /* <ProductGrid product={product} key={product.id} md={6} lg={4} index={index} /> */
     )
    )}
   </Row>

   {/* <Card className="bg-transparent shadow-none py-3">
    <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
     <div className="fs--1">
      <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
      <h5>¡No se han encontrado proyectos!</h5>
      <p className="mb-0">Su búsqueda no coincidió con ningún proyecto. Inténtalo de nuevo o crea un nuevo proyecto</p>
     </div>
    </Card.Body>
   </Card> */}

   <Card className="">
    <Card.Body
     className={classNames('d-flex justify-content-center', {
      'bg-light mt-n1': isGrid,
      'border-top': isList
     })}
    >
     <Pagination
      pageIndex={currentPage}
      pageCount={totalItems}
      canNextPage={canNextPage}
      canPreviousPage={canPreviousPage}
      previousPage={prevPage}
      nextPage={nextPage}
      gotoPage={goToPage}
      paginationArray={paginationArray}
     />
     {/* <br />
     <div>
      <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: 'fixed' }}>Prev</Tooltip>}>
       <Button variant="falcon-default" size="sm" disabled={!canPreviousPage} onClick={prevPage} className="me-2" trigger="focus">
        <FontAwesomeIcon icon="chevron-left" />
       </Button>
      </OverlayTrigger>
     </div>
     <ul className="pagination mb-0">
      {paginationArray.map(page => (
       <li key={page} className={classNames({ active: currentPage === page })}>
        <Button size="sm" variant="falcon-default" className="page me-2" onClick={() => goToPage(page)}>
         {page}
        </Button>
       </li>
      ))}
     </ul>
     <div>
      <OverlayTrigger
       trigger="click"
       placement="top"
       overlay={
        <Tooltip style={{ position: 'fixed' }} id="button-tooltip-2">
         Next
        </Tooltip>
       }
      >
       <Button variant="falcon-default" size="sm" disabled={!canNextPage} onClick={nextPage} trigger="focus">
        <FontAwesomeIcon icon="chevron-right" />
       </Button>
      </OverlayTrigger>
     </div> */}
    </Card.Body>
   </Card>
  </>
 );
};

AllPorjects.propTypes = {
 data: PropTypes.array.isRequired
};

export default AllPorjects;
